import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const DurableQueueService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  service.searchFailedQueueItems = (searchRequest) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    const response = axios.post(`${BASE_URL}/durable-queue/search`, searchRequest, {
      headers,
    });
    return response;
  };

  return service;
})();

export default DurableQueueService;
